/*---------------Libraries-----------------*/
import { createContext, useContext } from "react";

/*---------------Stores--------------------*/
import CartStore from "./cartStore";
import CommonStore from "./commonStore";
import CouponStore from "./couponStore";
import CustomerStore from "./customerStore";
import UserStore from "./userStore";
import ProductStore from "./productStore";
import OrderStore from "./orderStore";
import OrderDetailStore from "./orderDetailStore";
import Outletstore from "./outletStore";

interface Store {
  cartStore: CartStore;
  commonStore: CommonStore;
  couponStore: CouponStore;
  customerStore: CustomerStore;
  orderStore: OrderStore;
  orderDetailStore: OrderDetailStore;
  userStore: UserStore;
  productStore: ProductStore;
  outletStore:Outletstore
}

export const store: Store = {
  cartStore: new CartStore(),
  commonStore: new CommonStore(),
  couponStore: new CouponStore(),
  customerStore: new CustomerStore(),
  orderDetailStore: new OrderDetailStore(), 
  orderStore: new OrderStore(),
  userStore: new UserStore(),
  productStore: new ProductStore(),
  outletStore:new Outletstore() 
};

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
